module.exports = __webpack_public_path__ + "img/logoCliente.66a70dc2.png";